import "isomorphic-fetch";
import { BatchRequestStep, Client, BatchResponseContent } from "@microsoft/microsoft-graph-client/lib/src/browser";
import { BaseBatch } from "./baseBatch";
import { ISiteBatchInfo } from "../../interfaces/ISiteBatchInfo";
import { ISiteDriveItems } from "../../interfaces/ISiteDriveItems";
import { isSystemLibrary } from "./systemLibraryHelper";

export class DriveIdBatchHelper extends BaseBatch {
    constructor(client: Client) {
        super(client);
    }

    process = async (siteInfos: ISiteBatchInfo[]): Promise<ISiteDriveItems[]> => {
        const results: ISiteDriveItems[] = [];
        for (let i = 0; i < siteInfos.length; i += 20) {
            const siteInfoSlices: ISiteBatchInfo[] = siteInfos.slice(i, i + 20);

            const batchRequests: BatchRequestStep[] =
                siteInfoSlices.map((siteInfo, index: number) => {
                    return {
                        id: index.toString(),
                        request: new Request(`/sites/${siteInfo.siteId}/drives?$select=id,webUrl,name,sharepointIds&$expand=list($select=displayName)`, { method: "GET" })
                    }
                });

            const batchResponse = await this.buildBatchResponse(batchRequests);

            results.push(...(await this.getBatchResponse(siteInfoSlices, batchResponse)));
        }
        return results;
    }

    private async getBatchResponse(itemsToProcess: ISiteBatchInfo[], batchResponse: any): Promise<ISiteDriveItems[]> {
        const batchResponseContent = new BatchResponseContent(batchResponse);
        let result = await Promise.all(itemsToProcess.map((item, index) => (this.getBatchData(batchResponseContent, item, index))));
        return result;
    }

    private async getBatchData(batchResponseContent: BatchResponseContent, item: ISiteBatchInfo, index: number): Promise<ISiteDriveItems> {
        let response = await batchResponseContent.getResponseById(index.toString()).json();

        let driveItems = response.value
            // Skip built-in system libraries (e.g. Preservation Hold Library) - matched by url
            // segment, not the localized display name. See systemLibraryHelper.
            ?.filter(driveItem => !isSystemLibrary(driveItem.webUrl, driveItem.sharePointIds?.siteUrl))
            ?.map(item => {
                let splittedWebUrl = item.webUrl.split("/");
                return { ...item, documentLibraryRealName: splittedWebUrl[splittedWebUrl.length - 1], sharePointListId: item.sharePointIds?.listId }
            });

        return {
            site: item.site,
            driveItems: driveItems,
            siteId: item.siteId,
            mainUrl: item.mainWebUrl
        }
    }
}

